import {Component, inject, TemplateRef, ViewChild, ViewEncapsulation, ViewContainerRef } from '@angular/core';
import { EsimService } from './esim.service';
import { AWSLambda } from 'src/app/AWSLambda.service';
import { MatDialog } from '@angular/material/dialog';
import { NgSelectModule } from '@ng-select/ng-select';
import { Imagebuilder } from 'aws-sdk';
import { BuyNowModalComponent } from './buy-now-modal/buy-now-modal.component';
import { TopupsModalComponent } from './topups-modal/topups-modal.component';
import { AuthService, AuthStatus } from 'src/app/services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { Auth } from 'aws-amplify';
import { BehaviorSubject } from 'rxjs';
import { GlobalDataService } from '../../services/global-data.service';
import { MatSelect } from "@angular/material/select";
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import { bool } from 'aws-sdk/clients/signer';



@Component({
  selector: 'app-esim',
  templateUrl: './esim.component.html',
  styleUrls: ['./esim.component.scss']
})



export class EsimComponent {
  @ViewChild('countrySelect') countrySelect!: MatSelect;
  @ViewChild('filterInput') filterInputTemplate!: TemplateRef<any>;

  overlayRef: OverlayRef | null = null;

  private authService = inject(AuthService);
  loginForm: FormGroup;
  usuario: string = '';
  public IsOnline: boolean = false;
  public showSearchEsim: boolean = true;
  public showSpinner = false;
  private isRestoringFromQueryParams = false;

  public isDisabled = true;
  public isDisabled2 = true;
  params: any;

  

  countries: any[] = [];
  selectedCountry: string = '';
  packages: any[] = [];
  filteredPackages: any[] = [];
  packagesByCountry: { country: string, code: string, image: string, packages: any[] }[] = [];
  selectedType: string = '';
  types: string[] = ['Local', 'Regional','Global'];
  filteredCountries: any[] = [];
  tmpCountries: any[] = [];

  datapackage: {
    voice: any,
    amount: any,
    data: any,
    manual_installation: any,
    net_price: any,
    type: any,
    title: any,
    is_unlimited: any,
    qr_installation: any,
    price: any,
    id: any,
    text: any,
    day: any
  }[] = [];

  operadorpkg: {
    name: any,
    type: any,
    prepaid: any,
    esimtype: any,
    apn_type: any,
    apn_value: any,
    is_roaming: any,
    info: any,
    image: string,
    plan_type: any,
    activation_policy: any,
    is_kyc_verify: any,
    rechargeability: any,
    other_info: any,
  }[] = [];



  //oninit
  constructor(
    private route: ActivatedRoute,
    private esimService: EsimService,
    private dialog: MatDialog,
    private fb: FormBuilder,
    private _snackBar: MatSnackBar,
    private router: Router,
    private translateService: TranslateService,
    private globalDataService: GlobalDataService,
    private overlay: Overlay,
    private vcr: ViewContainerRef

    
  ) {
    this.loginForm = this.fb.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });
  }

  
  public sim_status_data:boolean = true;
  public esim_data_visible:string = ''
  public sim_status_data_voice:boolean = false;
  public esim_data_voice_visible: string = 'hidden';
  public dataVoiceEsims:boolean = true;
  public countryName:string = '';
  

  async ngOnInit() {
    try {
      const searchParams = new URLSearchParams(window.location.search);
      this.isIframe = searchParams.has('iframe');

      // Detectar si estamos en modo público (sin autenticación requerida)
      const isPublicMode = this.router.url.includes('/esimpublic');

      if (!this.isIframe) {
        // comprueba si se quiso comprar alguna esim antes del registro para llevar de nuevo al usuario a la vista de detalles de la que seleccionó
        const onSignupEsimData = sessionStorage.getItem('onsignup_esim_data');
        if (onSignupEsimData) {
          this.router.navigate(['/esim-details'], { state: { data: JSON.parse(onSignupEsimData) } });
          return;
        }

        if (isPublicMode) {
          // Modo catálogo público - NO requiere autenticación
          this.IsOnline = false;
          await this.loadPublicCatalog();
          return;  // Salir temprano - no intentar autenticar
        }

        // Modo privado - Requiere autenticación
        const usuario = await Auth.currentAuthenticatedUser();
        if (usuario != '') {
          this.IsOnline = true;
        }
      }
      this.route.queryParams.subscribe(async params => {
        this.params = params;

        // Restore packages list view from query params
        if (params['view'] === 'packages' && params['country'] && params['type']) {
          // Set flag to prevent infinite loop when loadEsimPackages() tries to set params
          this.isRestoringFromQueryParams = true;

          // Restore the search state
          this.selectedType = params['type'];

          // First, load packages for the selected type
          await this.getfilterPackages(this.selectedType);

          // Build filteredCountries array (same logic as onTypeChange)
          this.filteredCountries = [];
          this.tmpCountries = [];

          this.packagesByCountry.forEach(country => {
            const filteredPackages = country.packages.filter(pkg => pkg.type === this.selectedType);

            if (filteredPackages.length > 0) {
              this.filteredCountries.push({
                ...country,
                packages: filteredPackages
              });
            }
          });
          this.tmpCountries = this.filteredCountries;

          // Set the country and load packages
          this.selectedCountry = params['country'];

          // Hide search view
          this.showSearchEsim = false;

          // Load the filtered packages for the selected country
          this.loadEsimPackages();

          // Clear flag after restoration is complete
          this.isRestoringFromQueryParams = false;
        }

    });

    } catch (error) {
      // Solo hacer logout si estamos en modo privado
      const isPublicMode = this.router.url.includes('/esimpublic');

      if (isPublicMode) {
        // Modo público - mostrar catálogo sin autenticación
        console.log('Modo catálogo público - sin autenticación');
        this.IsOnline = false;
        await this.loadPublicCatalog();
      } else {
        // Modo privado - fallo de autenticación → logout
        this.authService.logout();
      }
      //this.router.navigate(['onboarding/login'], { replaceUrl: true });
      //window.location.reload();
    }

  }

  ngAfterViewInit() {
    this.countrySelect.openedChange.subscribe((opened) => {
      if (opened) {
        this.search('');
        const panel = document.querySelector('.custom-select-panel');
        if (panel) {
          const panelRect = panel.getBoundingClientRect();

          const positionStrategy = this.overlay
            .position()
            .flexibleConnectedTo(panel)
            .withPositions([{ originX: 'start', originY: 'top', overlayX: 'start', overlayY: 'top', offsetY: -48 }]);

          this.overlayRef = this.overlay.create({
            positionStrategy,
            scrollStrategy: this.overlay.scrollStrategies.reposition(),
            hasBackdrop: false,
            width: panelRect.width,
          });

          const portal = new TemplatePortal(this.filterInputTemplate, this.vcr);
          this.overlayRef.attach(portal);

          requestAnimationFrame(() => {
            const input = document.querySelector('.search-overlay-input input') as HTMLInputElement;
            input?.focus();
          });
        }
      } else {
        this.overlayRef?.detach();
      }
    });
  }

  onKey(event: Event) {
    this.filteredCountries = [];
    const searchValue = (event.target as HTMLInputElement).value;
    this.search(this.removeAccents(searchValue));
  }

  // Filter the states list and send back to populate the selectedStates
  search(value: string) {
    if (value == '') {
      this.onTypeChange();
    } else {
      let filter = value.toLowerCase();
      for (let i = 0; i < this.tmpCountries.length; i++) {
        let option = this.tmpCountries[i];
        if (this.removeAccents(option.country.toLowerCase()).indexOf(filter) >= 0) {
          this.filteredCountries.push(option);
        }
      }
    }
  }

  goToEsimSearcher() {
    this.filteredPackages = [];
    this.isDisabled2 = true;
    this.showSearchEsim = true;
    this.selectedCountry = '';
    this.search('');
    this.router.navigate(['/esim']);
  }

  goToMyEsims(): void {
    this.router.navigate(['/my-esims']);
  }

  toggleClassDataVoice() {
    this.sim_status_data_voice = !this.sim_status_data_voice;
    this.esim_data_voice_visible = this.sim_status_data_voice ? '' : 'hidden';
    this.sim_status_data = !this.sim_status_data;
    this.esim_data_visible = this.sim_status_data ? '' : 'hidden';
  }

  toggleClassData() {
    this.sim_status_data = !this.sim_status_data;
    this.esim_data_visible = this.sim_status_data ? '' : 'hidden';
    this.sim_status_data_voice = !this.sim_status_data_voice;
    this.esim_data_voice_visible = this.sim_status_data_voice ? '' : 'hidden';
  }

  isIframe: boolean  = false;

  async getfilterPackages(tipo: string): Promise<void> {
    this.showSpinner = true;
    try {
      //const apiPackages = await this.esimService.getfilteredPackages(tipo);
      const apiPackages = this.globalDataService.getEsimFilteredCountries(tipo);

      if (!apiPackages) {
        console.error('Response is undefined or empty');
        return;
      }

      // Parsear la respuesta si es una cadena JSON
      const apiResponse = typeof apiPackages === 'string' ? JSON.parse(apiPackages) : apiPackages;

      // Crear un mapa para organizar paquetes por país
      const packagesMap: { [key: string]: { country: string, image: string, packages: any[] } } = {};
      this.packagesByCountry = [];
      this.filteredPackages = [];

      // Procesar cada paquete
      apiResponse.forEach((pkg: any) => {
        if (pkg.pkg_country_code) {
          // Verificar si el país ya está en el mapa
          if (!packagesMap[pkg.pkg_country_code]) {
            // Crear una nueva entrada en el mapa para este país
            packagesMap[pkg.pkg_country_code] = {
              country: pkg.pkg_country,
              image: pkg.pkg_country_url || 'https://cdn-dev.zendy.tel/images/Promo-Zendy-3-24@3x.png', // Proporciona una ruta por defecto si es necesario
              packages: []
            };

            // Agregar el país a la lista
            this.packagesByCountry.push({
              country: pkg.pkg_country_title,
              code: pkg.pkg_country_code,
              image: pkg.pkg_country_url,
              packages: []
            });
          }

          // Agregar el paquete a la lista de paquetes del país correspondiente
          const countryPackages = packagesMap[pkg.pkg_country_code].packages;

          // Aquí agregamos la lógica del `type` para cada paquete
          const type = pkg.pkg_type || 'Local'; // Usa "Local" como predeterminado si no se encuentra `pkg_type`

          countryPackages.push({
            country: pkg.pkg_country,
            countryimg: packagesMap[pkg.pkg_country_code].image,
            voice: pkg.pkg_voice,
            amount: pkg.pkg_amount,
            data: pkg.pkg_data,
            manual_installation: pkg.pkg_manual_installation,
            net_price: pkg.pkg_price,
            type: type, // Asignar el `type` al paquete
            title: pkg.pkg_title,
            is_unlimited: pkg.pkg_is_unlimited,
            qr_installation: pkg.pkg_qr_installation,
            price: pkg.pkg_price,
            id: pkg.pkg_id,
            text: pkg.pkg_text,
            day: pkg.pkg_day,
            operador: [{
              operador: pkg.operador_title,
              type: pkg.operador_plan_type,
              prepaid: pkg.pkg_is_prepaid === 'true',
              esimtype: pkg.operador_apn_type,
              apn_type: pkg.operador_apn_type,
              apn_value: pkg.operador_apn_value,
              is_roaming: pkg.operador_is_roaming,
              info: pkg.operador_info,
              image: pkg.operador_url || 'https://cdn-dev.zendy.tel/images/Promo-Zendy-3-24@3x.png',
              plan_type: pkg.operador_plan_type,
              activation_policy: pkg.operador_activation_policy,
              is_kyc_verify: pkg.operador_is_kyc_verify,
              rechargeability: pkg.operador_rechargeability,
              other_info: pkg.operador_other_info
            }]
          });
        }
      });

      // Asignar los paquetes a los países en packagesByCountry
      this.packagesByCountry.forEach(pkg => {
        pkg.packages = packagesMap[pkg.code]?.packages || [];
      });

      // Ordenar países alfabéticamente
      this.packagesByCountry.sort((a, b) => a.country.localeCompare(b.country));

      // Llenar la lista por defecto con todos los paquetes
      // console.log('Packages by Country:', this.packagesByCountry);
      // console.log('Filtered Packages:', this.filteredPackages);
      //this.showSpinner = false;
    } catch (error) {
      console.error('Error fetching packages:', error);
    }
    finally{
      this.showSpinner = false;
    }
  }

  removeAccents(str: string): string {
    return (str || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "") // elimina tildes
      .replace(/[^a-zA-Z0-9\s]/g, "")  // elimina otros símbolos
      .toLowerCase();
  }

  onTypeChange2() {
    this.isDisabled2 = this.selectedCountry == "";
  }

  async onTypeChange(): Promise<void> {

    this.filteredCountries = [];
    this.tmpCountries = [];

    // si es Local asignar local, si es Regional asignar global
    const type = this.selectedType

    await this.getfilterPackages(type)

    this.isDisabled = this.selectedType == "";

    this.packagesByCountry.forEach(country => {
      const filteredPackages = country.packages.filter(pkg => pkg.type === type);

      if (filteredPackages.length > 0) {
        this.filteredCountries.push({
          ...country,
          packages: filteredPackages
        });
      }
    });
    this.tmpCountries = this.filteredCountries;
    this.selectedCountry = '';
    this.filteredPackages = [];
  }

  loadEsimPackages(): void {
    this.showSearchEsim = false;
    this.countryName = '';
    if (this.selectedCountry) {
      const selectedCountryData = this.packagesByCountry.find(pkg => pkg.code === this.selectedCountry);
      this.filteredPackages = selectedCountryData ? selectedCountryData.packages : [];
      this.filteredPackages.sort((a, b) => a.price - b.price);


      this.dataVoiceEsims = !this.filteredPackages.some(item => item.operador[0].plan_type === "data-voice-text");
      this.countryName = this.filteredCountries.find(tmpCountry => tmpCountry.code === this.selectedCountry).country;

      // Set query parameters to reflect package list view (only if not restoring from params)
      if (!this.isRestoringFromQueryParams) {
        this.router.navigate(['/esim'], {
          queryParams: {
            country: this.selectedCountry,
            type: this.selectedType,
            view: 'packages'
          }
        });
      }
    } else {
      this._snackBar.open('Please select a country', 'Close', { duration: 3000 });
    }
  }

  /**
   * Carga el catálogo público de eSIMs disponibles
   * Este método NO requiere autenticación
   */
  async loadPublicCatalog(): Promise<void> {
    // En modo público no hay eSIMs del usuario — solo se muestra el catálogo de búsqueda
    console.log('Catálogo público cargado - modo sin autenticación');
  }

  extractCountries(packages: any[]): any[] {
    const countryMap = new Map();

    //console.log(packages);

    packages.forEach(pkg => {
      if (!countryMap.has(pkg.country_code)) {
        countryMap.set(pkg.country_code, pkg.image);
      }
    });
    return Array.from(countryMap.entries()).map(([country_code, image]) => ({ country_code, image }));
  }

  openBuyNowDialog(packageData: any): void {

    const country = this.selectedCountry;
    const operador = packageData.operador[0].operador;

    this.dialog.open(BuyNowModalComponent, {
      width: '650px',
      data: { package: packageData, country: country, operador: operador }
    });
  }

  /**
   * Opens the purchase page for an eSIM package from the store
   */
  openPackagePurchaseDetails(packageData: any, package_id: string): void {
    console.log('>> Package purchase details', packageData);

    if (!this.isIframe) {
      this.router.navigate(['/esim-details'], {
        state: { data: packageData },
        queryParams: {
          package_id: package_id,
          country: this.selectedCountry,
          type: this.selectedType,
          view: 'packages'
        }
      });
    } else {
      sessionStorage.setItem('onsignup_esim_data', JSON.stringify(packageData));
      if (top?.location) {
        top.location.href = '/onboarding/register';
      }
    }
  }

  capitalizeCountryName(country: string): string {
    return country
      .split('-')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  calculatePercentage(total: number | undefined, remaining: number | undefined): number {
    if (!total || !remaining) {
      return 0;
    }
    return ((total - remaining) / total) * 100;
  }

}
